import { createLoadingReducer } from './utils';
import { ErrorCheckObject } from '@/types';

export default createLoadingReducer<ErrorCheckObject>('ERROR_CHECK');
